import type { SVGProps } from "react";

const socials = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/trendoramartss",
    icon: (props: SVGProps<SVGSVGElement>) => (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/trendora_marts/?hl=en",
    icon: (props: SVGProps<SVGSVGElement>) => (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@trendora.marts",
    icon: (props: SVGProps<SVGSVGElement>) => (
      <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91.02.26 2.61 2.62 4.63 5.33 4.61v4.97c-1.66-.01-3.19-.47-4.52-1.26v5.72c0 4.58-3.85 8.32-8.58 8.06-3.93-.21-7.2-3.28-7.31-7.22-.06-2.63 1.35-5.05 3.68-6.46 1.86-1.14 4.17-1.46 6.24-.74.07.03.14.06.21.09v4.42c-2.32-1.09-5.14-.19-6.34 2.01-.86 1.59-.49 3.6 1.01 4.72 1.55 1.15 3.7 1.07 5.16-.2.03-.02.06-.05.09-.07.01-.47.03-.95.03-1.43V0h3.44c.02 2.54 1.77 4.75 4.23 5.22v-3.05c-1.41-.2-2.71-.83-3.67-1.76z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@trendoramarts",
    icon: (props: SVGProps<SVGSVGElement>) => (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
];

interface SocialLinksProps {
  variant?: "contact" | "footer";
  className?: string;
}

export function SocialLinks({ variant = "contact", className = "" }: SocialLinksProps) {
  const isFooter = variant === "footer";

  return (
    <div className={`flex items-center gap-4 flex-wrap ${className}`}>
      {socials.map((social) => (
        <a
          key={social.name}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.name}
          className={
            isFooter
              ? "h-10 w-10 grid place-items-center rounded-full border border-white/20 text-white hover:bg-teal hover:text-white hover:border-teal transition-all duration-300 hover:scale-110 hover:-translate-y-0.5"
              : "h-10 w-10 grid place-items-center rounded-full bg-gradient-gold text-gold-foreground hover:shadow-md transition-all duration-300 hover:scale-110 hover:-translate-y-0.5"
          }
        >
          <social.icon className="h-5 w-5" />
        </a>
      ))}
    </div>
  );
}
